export default class InativacaoLoteStatusItemModel {
  constructor(
    {
      id,
      tipoItem,
      operacao,
      cnpjOrigem,
      empresaOrigemNome,
      cnpjDestino,
      empresaDestinoNome,
      identificadorSubDado,
      sucesso,
      integradoWbc,
      detalheProcessamento,
    } = new Object()
  ) {
    this._id = id;
    this._tipoItem = tipoItem;
    this._operacao = operacao;
    this._cnpjOrigem = cnpjOrigem;
    this._empresaOrigemNome = empresaOrigemNome;
    this._cnpjDestino = cnpjDestino;
    this._empresaDestinoNome = empresaDestinoNome;
    this._identificadorSubDado = identificadorSubDado;
    this._sucesso = sucesso;
    this._integradoWbc = integradoWbc;
    this._detalheProcessamento = detalheProcessamento;
  }

  get id() {
    return this._id;
  }

  set id(id = null) {
    this._id = id;
  }

  get tipoItem() {
    return this._tipoItem;
  }

  set tipoItem(tipoItem = null) {
    this._tipoItem = tipoItem;
  }

  get operacao() {
    return this._operacao || "INATIVAR";
  }

  set operacao(operacao = "INATIVAR") {
    this._operacao = operacao;
  }

  get cnpjOrigem() {
    return this._cnpjOrigem || null;
  }

  set cnpjOrigem(cnpjOrigem = null) {
    this._cnpjOrigem = cnpjOrigem;
  }

  get empresaOrigemNome() {
    return this._empresaOrigemNome || null;
  }

  set empresaOrigemNome(empresaOrigemNome = null) {
    this._empresaOrigemNome = empresaOrigemNome;
  }

  get cnpjDestino() {
    return this._cnpjDestino || null;
  }

  set cnpjDestino(cnpjDestino = null) {
    this._cnpjDestino = cnpjDestino;
  }

  get empresaDestinoNome() {
    return this._empresaDestinoNome || null;
  }

  set empresaDestinoNome(empresaDestinoNome = null) {
    this._empresaDestinoNome = empresaDestinoNome;
  }

  get identificadorSubDado() {
    return this._identificadorSubDado || null;
  }

  set identificadorSubDado(identificadorSubDado = null) {
    this._identificadorSubDado = identificadorSubDado;
  }

  get sucesso() {
    return this._sucesso || false;
  }

  set sucesso(sucesso = false) {
    this._sucesso = sucesso;
  }

  get integradoWbc() {
    return this._integradoWbc || false;
  }

  set integradoWbc(integradoWbc = false) {
    this._integradoWbc = integradoWbc;
  }

  get detalheProcessamento() {
    return this._detalheProcessamento || null;
  }

  set detalheProcessamento(detalheProcessamento = null) {
    this._detalheProcessamento = detalheProcessamento;
  }
}
